module.exports = __webpack_public_path__ + "img/canales-atencion.1072b70a.svg";